import {api} from '@/http'

// 谁看过我列表
const getWhoSeeMeList = (data, callback, back) => {
  api('/api/who_see_me', 'get', data, callback, back)
}

// 我看过谁列表
const getWhoISeeList = (data, callback, back) => {
  api('/api/who_i_see', 'get', data, callback, back)
}

export default {
  getWhoSeeMeList,
  getWhoISeeList
}



// WEBPACK FOOTER //
// ./src/api/record/index.js